import { SimCardDetail, SimCardDetailSimStatus } from "@/services/model";
import {
  hasNumberPorting,
  hasPendingService,
  isNumberPortingTile,
} from "@/utils/deviceUtils";
import { getProductCategory, getProductIdFromSim } from "@/utils/productMatrix";

/**
 * Whether a SIM should receive bulk cockpit roaming enrichment
 * (`/sim/roamingInfo` and `/sim/roamingCallPackageUsage`).
 *
 * Matches the tiles that actually display roaming usage: active or expiring
 * mobile SIMs with verified KYC, no subscription order in progress, and no
 * number porting.
 */
export const shouldFetchCockpitRoamingForSim = (
  sim: SimCardDetail,
  needsIdCheck?: boolean,
): boolean => {
  if (
    sim.simStatus !== SimCardDetailSimStatus.green &&
    sim.simStatus !== SimCardDetailSimStatus.yellow
  ) {
    return false;
  }

  // Cockpit roaming widgets only appear once account KYC is verified.
  if (needsIdCheck !== false) {
    return false;
  }

  if (
    hasPendingService(sim) ||
    hasNumberPorting(sim) ||
    isNumberPortingTile(sim)
  ) {
    return false;
  }

  return getProductCategory(getProductIdFromSim(sim)) === "mobile";
};
